/*
 * Copyright (c) 2016 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Type} from '@angular/core';
import {IfExpanded} from './if-expanded';

export {IfExpanded} from './if-expanded';

export const /** @type {?} */ EXPAND_DIRECTIVES: Type<any>[] = [IfExpanded];
